import { IPrimaryBasicData, PrimarySDKComponent } from '@fiverr-private/primary_section_sdk';
import { PrimaryDefault } from './DefaultPrimaryComponent';

export * from './DefaultPrimaryFunctions';
export const PrimaryDefaultSDKComponentImpl: PrimarySDKComponent<IPrimaryBasicData> = {
    PrimaryComponent: PrimaryDefault,
};
